import { TableCell, TableRow } from "@material-ui/core";
import { FC, memo } from "react";
import { ScheduleSelectItem, ScheduleUserData } from "types/Schedule";
import { ScheduleTableColumn } from "./scheduleTable";
import { ScheduleCell } from "./ScheduleCell";

interface ScheduleRowProps {
  user: ScheduleUserData;
  columns: ScheduleTableColumn[];
  classes: any;
  currentUserRole: number;
  idListForDelete: ScheduleSelectItem[];
  idListForSMS: number[];
  isSelected: boolean;
  tableNumber: number
}

export const ScheduleRow: FC<ScheduleRowProps> = memo(
  ({ user, columns, classes, currentUserRole, idListForSMS, idListForDelete, isSelected, tableNumber }) => (
    <TableRow>
      {columns.map((column, index) => (
        <TableCell
          key={`schedule-cell-${column.id}-${user.id}`}
          className={`${classes.tableCell} ${isSelected ? classes.activeRow : ""} ${
            index > 0 ? classes.tableBorderLeft : ""
          } ${tableNumber === 1 && index !== 0 && !["user"].includes(column.id) ? classes.fixedWidth : ""}`}
        >
          <ScheduleCell
            columnId={column.id}
            userData={user}
            date={column.date}
            classes={classes}
            currentUserRole={currentUserRole}
            idListForDelete={idListForDelete}
            idListForSMS={idListForSMS}
          />
        </TableCell>
      ))}
    </TableRow>
  ),
);
